import type FinishedResponseInteractionService from './finished-response-interaction.service';
import type {ActionResponse, SmsSendRequest} from 'typings/portaro.be.types';
import {ngAsync} from '../utils/ng-@decorators';
import type {AjaxService} from 'core/data-services/ajax.service';

export default class SmsService {
    public static readonly serviceName = 'smsService';

    private static readonly SMS_ROUTE = 'sms';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    @ngAsync()
    public async sendSms(request: SmsSendRequest): Promise<void> {
        try {
            const actionResponse = await this.sendSmsUsingAjax(request);
            return this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            throw exceptionResponse;
        }
    }

    private async sendSmsUsingAjax(request: SmsSendRequest): Promise<ActionResponse> {
        return this.ajaxService
            .createRequest(SmsService.SMS_ROUTE)
            .post(request);
    }
}